export default __webpack_public_path__ + "static/loader-4e1130dac2f569d8323ad1c3ffa47e85.gif";